var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMapPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2484 13.3197C22.2484 19.5943 14.5291 27.2385 12.5714 29.0764C12.3121 29.3197 11.9363 29.3197 11.677 29.0764C9.71926 27.2385 2 19.5943 2 13.3197C2 7.36679 6.53276 2.54102 12.1242 2.54102C17.7156 2.54102 22.2484 7.36679 22.2484 13.3197Z",
    stroke: "#3B4B53",
    strokeWidth: 3.71654,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5254 17.7154C14.123 17.7154 15.4181 16.2961 15.4181 14.5452C15.4181 12.7943 14.123 11.375 12.5254 11.375C10.9279 11.375 9.63281 12.7943 9.63281 14.5452C9.63281 16.2961 10.9279 17.7154 12.5254 17.7154Z",
    stroke: "#3B4B53",
    strokeWidth: 3.71654,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMapPin);
export default __webpack_public_path__ + "static/media/ic_map_pin.3ffb8d2aaa869761e8fce00a60a6044c.svg";
export { ForwardRef as ReactComponent };